<template>
<div>
    <NavTopMobile></NavTopMobile>
    <div class="container-fluid bg-soft">
        <div class="row">
            <div class="col-12">
                <NavSideBar></NavSideBar>
                <main class="content">
                    <NavTop></NavTop>
                    <div v-if="page!='dashboard'" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                        <div class="d-block mb-4 mb-md-0">
                            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                                <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                    <li class="breadcrumb-item"><a href="#"><span class="fa fa-home"></span></a></li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'index'}">Dashboard</router-link>
                                    </li>
                                    <li class="capitalize breadcrumb-item active" aria-current="page">{{page}}</li>
                                </ol>
                            </nav>
                            <h2 class="h4 capitalize">{{action}} {{page}}</h2>
                        </div>
                        <div class="btn-toolbar mb-2 mb-md-0">
                            <div class="btn-group">
                                <!-- page == 'site_content' || -->
                                <div v-if=" page == 'logo' || page == 'setting'  || page == 'pages' || page == 'subcategory'|| page == 'supersubcategory'|| page == 'varient' || page == 'Contact' || page == 'Review' || page == 'Order'"></div>
                                <div v-else>
                                    <router-link v-if="(page != 'OptionValueTypes'  && page != 'Quantity' && page != 'BulkUploadProductVue' && page != 'DeliveryCharge' && page != 'admins' && page != 'CouponVue' && page != 'SEOKeywords') && (action=='view' || action=='edit')" :to="{name : 'index', params: { page: page, action: 'add' }}" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-plus"></i> Add new</router-link>
                                </div>
                                <router-link v-if="action=='add' || action=='edit'" :to="{name : 'index', params: { page: page }}" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-eye"></i> View All</router-link>
                            </div>
                        </div>
                    </div>
                    <component :is="page" :page="page" :type="type" :action="action" :id="id" :code="code"></component>
                </main>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NavTopMobile from './include/NavTopMobile';
import NavSideBar from './include/NavSideBar';
import NavTop from './include/NavTop';
import dashboard from './pages/Dashboard';
import pages from './pages/Pages';
import media from './pages/Media';
import product from './pages/Product';
import users from './pages/Users';
import slider from './pages/slider';
import category from './pages/Category';
import brand from './pages/brand';
import Shipping from './pages/Shipping';
import Order from './pages/Order';
import Site_content2 from './pages/Site_content-2';
import site_content from './pages/Site_content';
import setting from './pages/Setting';
import partners from './pages/Partners';
import testimonial from './pages/Testimonial';
import transaction from './pages/Transaction';
import logo from './pages/Logo';
import supersubcategory from './pages/Supersubcategory';
import subcategory from './pages/Subcategory';
import varient from './pages/Varient';
import pincode from './pages/Pincode';
import faqs from './pages/faqs';
import RoyaltyPoint from './pages/RoyaltyPoint';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import State from './pages/State';
import Review from './pages/Review';
import Gallery from './pages/Gallery.vue';
import OptionValueTypes from './pages/OptionValueTypes.vue';
import Options from './pages/Options.vue';
import OptionsValues from './pages/OptionsValues.vue';
import Quantity from './pages/Quantity.vue';
import BulkUploadProductVue from './pages/bulkUploadProduct.vue'
import CouponVue from './pages/coupon.vue';
import blogs from './pages/blogs.vue';
import DeliveryCharge from './pages/deliveryCharge.vue';
import Admins from './pages/adminUsers.vue';
import SEOKeywords from './pages/seoKeywords.vue';
import popup_banner from './pages/popupBanner.vue';
// import imageTesting from './pages/imageTesting.vue';

export default {
    components: {
        // imageTesting,
        popup_banner,
        blogs,
        Admins,
        Quantity,
        Options,
        OptionsValues,
        OptionValueTypes,
        Admin,
        State,
        Review,
        CouponVue,
        NavTopMobile,
        NavSideBar,
        Site_content2,
        subcategory,
        supersubcategory,
        transaction,
        setting,
        varient,
        testimonial,
        NavTop,
        partners,
        dashboard,
        logo,
        Order,
        pages,
        media,
        site_content,
        product,
        users,
        category,
        slider,
        brand,
        Shipping,
        pincode,
        faqs,
        Contact,
        RoyaltyPoint,
        Gallery,
        BulkUploadProductVue,
        DeliveryCharge,
        SEOKeywords
    },
    data() {
        return {
            type: '',
            page: this.$route.params.page && typeof this.$route.params.page != 'undefined' ? this.getPage(this.$route.params.page) : 'dashboard',
            action: this.$route.params.action && typeof this.$route.params.action != 'undefined' ? this.$route.params.action : 'view',
            id: this.$route.params.id && typeof this.$route.params.id != 'undefined' ? this.$route.params.id : null,
            code: this.$route.params.code && typeof this.$route.params.code != 'undefined' ? this.$route.params.code : null,
        }
    },
    methods: {
        getPage(page) {
            this.type = '';
            if (page == 'vendor' || page == 'driver' || page == 'user' || page == 'admin') {
                this.type = page;
                return 'users';
            }
            return page;
        }
    },
    computed: {

    },
    watch: {
        '$route.params.page': function (page) {
            this.page = typeof page != 'undefined' ? this.getPage(page) : 'dashboard'
        },
        '$route.params.action': function (action) {
            this.action = typeof action != 'undefined' ? action : 'view'
        },
        '$route.params.id': function (id) {
            this.id = typeof id != 'undefined' ? id : null
        },
        '$route.params.code': function (code) {
            this.code = typeof code != 'undefined' ? code : null
        }
    },
}
</script>
